import { Box, Button, Modal, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { generateResponsiveStyle } from "../utils/ModalStyle";
import { showError } from "../constants/toast";
import { useLazyGetUserCSVQuery, useLazyGetUserExcelQuery } from "../services/users";
import { handleDownload } from "../utils/mediaUpload";

// customers files
type props = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
};

const ExportModal1 = ({ open, setOpen }: props) => {
    const style = generateResponsiveStyle();
    const [exportCSV] = useLazyGetUserCSVQuery();
    const [exportExcel] = useLazyGetUserExcelQuery();


    const handleExportCsv = async () => {
        try {
            const res = await exportCSV({}).unwrap();
            if (res?.statusCode === 200) {
                handleDownload(res?.data,"users")
                // window.open(res?.data || "");
            }
        } catch (error: any) {
            showError(error?.message);
        }
    };
    const handleExportExcel = async () => {
        try {
            const res = await exportExcel({}).unwrap();
            if (res?.statusCode === 200) {
                handleDownload(res?.data,"users")
            }
        } catch (error: any) {
            showError(error?.message);
        }
    };
    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="logout_mdl"
        >
            <Box sx={style}>
                <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    sx={{ textAlign: "center", fontSize: "20px", color: "#1c6975" }}
                >
                    Please select a file format
                </Typography>

                <div className="flexdiv">
                    <Button
                        className="yesBtn"
                        sx={{ color: "#252525", border: "1px solid #252525" }}
                        onClick={() => {
                            setOpen(false);
                            handleExportCsv();
                        }}
                    >
                        Export Csv
                    </Button>
                    <Button
                        sx={{ color: "#252525", border: "1px solid #252525" }}
                        onClick={() => {
                            setOpen(false);
                            handleExportExcel();
                        }}
                    >
                        Export Excel
                    </Button>
                </div>
            </Box>
        </Modal >
    );
};

export default ExportModal1;
